import React from "react";
import {
  Column,
  DataGrid,
  Paging,
  Pager,
  FormItem,
  Lookup,
  Button,
} from "devextreme-react/data-grid";
import { Editing } from "devextreme-react/scheduler";
import PaginaToolbar from "../components/PaginaToolbar";
import { criarCadastrarLeisDs } from "../DataSources";
import UserInfo from "../UserInfo";
import uiInfo from "../ui-info";
import { Popup } from "devextreme-react/popup";
import FileUploader from "devextreme-react/file-uploader";
import RegularButton from "devextreme-react/button";
import notify from "devextreme/ui/notify";
import Form from "devextreme-react/form";
export default class CadastroLeisBox extends React.Component {
  constructor() {
    super();
    this.initNewRow = this.initNewRow.bind(this);
    this.formElement = React.createRef();
    this.enviarArquivo = this.enviarArquivo.bind(this);

    this.state = {
      popupEnviarArquivo: false,
    };

    this.simNaoOptions = [
      { id: 0, descricao: "Não" },
      { id: 1, descricao: "Sim" },
    ];

    this.tipoOptions = [
      { id: 0, descricao: "Leis e Decretos" },
      { id: 1, descricao: "Formulários Portal" },
      { id: 2, descricao: "Manuais NFS-e" },
    ];
  }

  enviarArquivo() {
    notify("Arquivo enviado!", "success");
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <PaginaToolbar titulo="Leis">
          <DataGrid
            dataSource={criarCadastrarLeisDs()}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            focusedRowEnabled={true}
            wordWrapEnabled={true}
            onInitNewRow={this.initNewRow}
          >
            <Editing
              mode="row"
              useIcons={true}
              allowUpdating={true}
              allowDeleting={true}
            />
            <Column type="buttons" width={110}>
              <Button name="edit" />
              <Button name="delete" />
              <Button
                hint="Enviar Arquivo"
                icon="upload"
                onClick={() => this.setState({ popupEnviarArquivo: true })}
              />
            </Column>
            <Column
              dataField={"id"}
              caption={"#"}
              width={"80"}
              allowEditing={false}
              alignment={"center"}
            />
            <Column
              dataField={"prefeituraId"}
              caption={"Prefeitura"}
              visible={false}
            >
              <FormItem visible={false}></FormItem>
            </Column>
            <Column dataField={"possuiArquivo"} allowEditing={false}>
              <Lookup
                dataSource={this.simNaoOptions}
                displayExpr={"descricao"}
                valueExpr={"id"}
              />
            </Column>
            <Column dataField={"exibirNoPortal"}>
              <Lookup
                dataSource={this.simNaoOptions}
                displayExpr={"descricao"}
                valueExpr={"id"}
              />
            </Column>
            <Column dataField={"tipo"}>
              <Lookup
                dataSource={this.tipoOptions}
                displayExpr={"descricao"}
                valueExpr={"id"}
              />
            </Column>
            <Column dataField={"descricao"} caption={"Descrição"} />

            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>

        <Popup
          visible={this.state.popupEnviarArquivo}
          onHiding={() => this.setState({ popupEnviarArquivo: false })}
          dragEnabled={false}
          closeOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          width={"60%"}
          height={500}
          title="Enviar Arquivo"
        >
          <form
            id="form"
            ref={this.formElement}
            method="post"
            action=""
            encType="multipart/form-data"
          >
            <div
              className="fileuploader-container"
              style={{
                border: "1px solid #d3d3d3",
                margin: "20px 20px 0 20px",
              }}
            >
              <FileUploader
                selectButtonText="Escolher..."
                labelText=""
                uploadMode="useForm"
              />
            </div>
            <RegularButton
              text="Enviar"
              type="success"
              onClick={this.enviarArquivo}
              style={{ marginTop: "50px", marginRight: "20px", float: "right" }}
            />
          </form>
        </Popup>
      </div>
    );
  }

  initNewRow(e) {
    e.data.prefeituraId = UserInfo.getPrefeitura();
  }
}
